import { createPool } from '@/api'
import { useFeedback } from '@/utils/antdApp'
import { useState, useEffect } from 'react'
import PoolLayout from './Layout'
import PoolListPage from './pool'  //全部股票池
import PoolDetail from './detail'  //股票池详情
import StockDetail from './stockDetail'  //股票详情
import StockNewKBDetailPage from '@/pages/StockNewKB/detail'
import AddStockPoolDialog from './components/add-stock-pool-dialog'
import type { Stock, StockPool } from '@/types'
import { getPools } from '@/api'

interface StockPoolItem extends StockPool {
    open: boolean
}

export default function PoolPage() {
    const [tab, setTab] = useState<'stock' | 'stock-new-kb' | 'poolDetail' | 'poolList'>('poolList')
    const { message } = useFeedback()
    const [poolList, setPoolList] = useState<StockPoolItem[]>([])

    const load = () => getPools().then((data) => {
        const list = Array.isArray(data) ? data : []
        setPoolList(list.map((m: StockPool) => ({
            ...m,
            open: false,
            stocks: Array.isArray(m.stocks) ? m.stocks : [],
        })))
    }).catch(() => message.error('加载失败'))

    useEffect(() => {
        load()
    }, [])
    
    const [stockCode, setStockCode] = useState<string>('')
    const [idx, setIdx] = useState<number>(0)
    const [poolId, setPoolId] = useState<number>(0)
    const [visible, setVisible] = useState(false)

    const goPoolList = () => {
        setTab('poolList')
        load()
    }

    const onRefresh = () => {
        load()
    }

    //进入股票池详情
    const onDetail = (poolId: number, idx: number) => {
        setTab('poolDetail')
        setPoolId(poolId)
        setIdx(idx)
    }

    //进入新知识库详情
    const onSelectStockNewKB = (stock: Stock) => {
        setStockCode(stock.code)
        setTab('stock-new-kb')
    }

    //进入股票详情
    const onSelectStock = (stock: Stock) => {
        setStockCode(stock.code)
        setTab('stock')
    }

    //进入股票池股票列表
    const onSelectPool = (pool: StockPool, idx: number) => {
        setTab('poolDetail')
        setPoolId(pool.id)
        setIdx(idx)
    }

    //添加股票池
    const onAddPool = ({name, description, is_favorite}: {name: string, description: string, is_favorite: boolean}) => {
        createPool({name, description, is_favorite}).then(() => {
            message.success('创建成功')
            load()
            setVisible(false)
            setTab('poolList')
        }).catch(() => message.error('创建失败'))
    }
    return (
        <PoolLayout
            poolId={poolId}
            stockCode={stockCode}
            poolList={poolList}
            onSelectStockNewKB={onSelectStockNewKB}
            onSelectPool={onSelectPool}
            createPool={() => setVisible(true)}
        >
            {
                tab === 'stock' ? <StockDetail stockCode={stockCode} onBack={goPoolList} /> :
                tab === 'stock-new-kb' ? <StockNewKBDetailPage code={stockCode} onBack={() => setTab('poolDetail')} /> :
                tab === 'poolDetail' ?
                <PoolDetail
                    poolId={poolId} idx={idx}
                    toDetail={onSelectStock}
                    toNewKB={onSelectStockNewKB}
                    onBack={goPoolList}
                    onPoolChanged={onRefresh}
                /> :
                <PoolListPage
                    poolList={poolList}
                    refresh={onRefresh}
                    toDetail={onDetail}
                    addPool={() => setVisible(true)}
                    toStock={onSelectStock}
                />
            }
            <AddStockPoolDialog 
                open={visible} 
                onCancel={() => setVisible(false)} 
                onAdd={onAddPool} 
            />
        </PoolLayout>
    )
}
